<template>
  <div class="wx-msg page-box">
    <div class="page-content">
      <div class="content-header query-header">
        <el-row
          :gutter="10"
        >
          <el-col
            :lg="4"
            :md="6"
            :sm="24"
            :xs="24"
            class="el-col-el"
          >
            <el-select
              style="width: 100%"
              v-model="startTime"
              placeholder="时间"
              clearable
              @change="searchHandle"
            >
              <el-option
                v-for="(name,key) in timeSelections"
                :key="key"
                :value="name"
                :label="key"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :lg="4"
            :md="6"
            :sm="24"
            :xs="24"
            class="el-col-el"
          >
            <el-select
              style="width: 100%"
              v-model="msgTypes"
              placeholder="消息类型"
              clearable
              @change="searchHandle"
            >
              <el-option
                value=""
                label="不限类型"
              ></el-option>
              <el-option
                value="text,image,voice,shortvideo,video,news,music,location,link"
                label="消息"
              ></el-option>
              <el-option
                value="event,transfer_customer_service"
                label="事件"
              ></el-option>
            </el-select>
          </el-col>
          <vs-button
            type="info"
            class="search-btn btn box-item"
            @click="searchHandle"
          >查询</vs-button>
        </el-row>
        <div class="text-gray">
          24小时内消息可回复。此后台展示消息有一分钟左右延迟，如需畅聊请使用
          <a href="https://mpkf.weixin.qq.com/" target="_blank">公众平台客服</a>
        </div>
      </div>
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              用户名
            </vs-th>
            <vs-th>
              头像
            </vs-th>
            <vs-th>
              事件
            </vs-th>
            <vs-th>
              时间
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{getUserInfo(tr.openid).nickname || '--'}}
              </vs-td>
              <vs-td>
                <img
                  v-if="getUserInfo(tr.openid).headimgurl"
                  class="header-img"
                  :src="getUserInfo(tr.openid).headimgurl"
                  referrerPolicy="no-referrer"
                />
                <span
                  v-else
                >-</span>
              </vs-td>
              <vs-td>
                <wx-msg-preview
                  :msg="tr"
                  singleLine></wx-msg-preview>
              </vs-td>
              <vs-td
              >
                {{$moment(tr.createTime).calendar()}}
              </vs-td>
              <vs-td>
                <span
                  v-if="canReply(tr.createTime)"
                  @click="replyHandle(tr.openid)"
                  class="el-icon-s-promotion"
                >回复</span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <!-- 弹窗, 消息回复 -->
    <wx-msg-reply
      ref="wxMsgReply"
      @success="onReplyed"
    ></wx-msg-reply>
  </div>
</template>

<script>
import WxMsgReply from '@/components/wx-msg-reply'
import WxMsgPreview from '@/components/wx-msg-preview'
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils'
import initData from "@/mixins/initData";
const TIME_FORMAT = 'YYYY/MM/DD hh:mm:ss';
export default {
  name: "index",
  components: {
    WxMsgPreview,
    WxMsgReply,
  },
  data() {
    let _this = this;
    return {
      startTime: _this.$moment().subtract(1, 'days').format(TIME_FORMAT),
      msgTypes: '',
      timeSelections:{
        '近24小时': _this.$moment().subtract(1, 'days').format(TIME_FORMAT),
        '近3天': _this.$moment().subtract(3, 'days').format(TIME_FORMAT),
        '近7天': _this.$moment().subtract(7, 'days').format(TIME_FORMAT),
        '近30天': _this.$moment().subtract(30, 'days').format(TIME_FORMAT),
      },
      userDataList: [],
      size: 20,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo','selectedAppid']),
  },
  watch: {
    selectedAppid(newValue, oldValue) {
      if(newValue){
        this.searchHandle();
      }
    }
  },
  mounted(){
    this.searchHandle();
  },
  methods: {
    parseTime,
    getUserInfo(openid){
      return this.userDataList.find( u => u.openid == openid ) || {nickname:'--',headimgurl:''}
    },
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },

    beforeInit(){
      this.url = '/wx/manage/wxMsg/list';
      this.params = {
        page: this.page,
        limit: 20,
        'msgTypes': this.msgTypes,
        'startTime':this.startTime,
        'sidx': 'create_time',
        'order': 'desc'
      }
      return true;
    },
    refreshUserList(msgList){
      let openidList= msgList.map( msg => msg.openid ).filter( openid => !this.userDataList.some( u => u.openid == openid ));
      if(!openidList.length)return
      openidList = Array.from(new Set(openidList))//去重
      this.$http({
        url: '/wx/manage/wxUser/listByIds',
        method: 'post',
        data: openidList,
      }).then((data) => {
        if (data.code === 200) {
          this.userDataList = this.userDataList.concat(data.data)
        }
      })
    },
    // 是否可回复，24小时内可回复
    canReply(time){
      return new Date(time).getTime()>new Date().getTime()-24*60*60*1000
    },
    // 回复消息
    replyHandle(openid) {
      this.$nextTick(() => {
        this.$refs.wxMsgReply.init(openid)
      })
    },
    searchHandle(){
      this.page = 1;
      this.init().then(() => {
        this.refreshUserList(this.listData);
      });
    },
    onReplyed(replyMsg){
      this.listData.unshift({
        openid : replyMsg.openid,
        msgType : replyMsg.replyType,
        detail : {
          content : replyMsg.replyContent
        },
        inOut : 1,
        createTime : new Date()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wx-msg {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .content-header {
    padding: 20px 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .header-img {
    width: 60px;
    height: 60px;
  }
}
</style>
